import { Component, OnInit } from '@angular/core';
import { KycService } from '@app/core/kyc.service';
import { routerTransition } from '../../router.animations';

import { QuestionControlService } from '@app/core/question-control.service';
import { QuestionService } from '@app/core/question.service';
import { renderNeedData, getAmountOfRegularSavings } from '@app/features/my-needs/my-needs';
import * as MyNeedsConstants from '@app/features/my-needs/constants';
import { Router } from '@angular/router';
import { NavTabService } from '@app/core/navTab.service';

declare var $;

@Component({
  selector: 'app-my-needs',
  templateUrl: './my-needs.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }
})
export class MyNeedsComponent implements OnInit {
  needs = [];
  needData: any;
  choosenNeed: any;
  selectedModal = '';
  showModal = false;
  amountOfRegularSavings: number;
  age: number;

  readonly INCOME_PROTECTION_KEY = MyNeedsConstants.INCOME_PROTECTION_KEY;
  readonly RETIREMENT_KEY = MyNeedsConstants.RETIREMENT_KEY;
  readonly SAVINGS_KEY = MyNeedsConstants.SAVINGS_KEY;
  readonly BIG_INVESTMENT_PLAN_KEY = MyNeedsConstants.BIG_INVESTMENT_PLAN_KEY;
  readonly HEALTH_KEY = MyNeedsConstants.HEALTH_KEY;

  constructor(
    private kycService: KycService,
    private questionService: QuestionService,
    private qcs: QuestionControlService,
    private router: Router,
    private navTabService: NavTabService) {
  }

  ngOnInit() {
    this.age = this.kycService.kyc.profile.userProfile.age;
    this.needs = this.kycService.kyc.needs.needs;
    this.kycService.kyc.needs.needs.forEach(need => {
      if (need.key === MyNeedsConstants.SAVINGS_KEY) {
        this.amountOfRegularSavings = getAmountOfRegularSavings(
          this.getValueInNeedItem(need, 'myYearlyIncome'),
          this.getValueInNeedItem(need, 'savingPercentForYearlyIncome'),
          this.getValueInNeedItem(need, 'currentSavings'),
          this.getValueInNeedItem(need, 'otherSavings'),
          this.getValueInNeedItem(need, 'timeSavings') - 1,
          this.getValueInNeedItem(need, 'investmentRates'),
          this.getValueInNeedItem(need, 'inflationRates')
        );
      }
    });
  }

  setSelectedModal(key: string): void {
    this.kycService.kyc.needs.needs.forEach(need => {
      if (need.key === key) {
        this.choosenNeed = need;
        this.choosenNeed.iconColor = MyNeedsConstants.ICON_BLUE;
      }
    });
    this.choosenNeed.questionRaws.map(item => {
      if (item.key === "yearRetirement") {
        item.options.range.min = this.age;
        item.value = this.age;
      }
    });

    this.needData = renderNeedData(this.choosenNeed.questionRaws, this.questionService, this.qcs);
    this.needData.userAge = this.kycService.kyc.profile.userProfile.age;
    this.needData.gender = Number(this.kycService.kyc.profile.userProfile.gender);
    this.selectedModal = key;
    this.showModal = true;
  }

  onCloseModal() {
    this.kycService.kyc.needs.needs.forEach(need => {
      if (need.key === this.choosenNeed.key) {
        if (!need.displayData) {
          need.displayData = true;
        }
        need.questionRaws.forEach(question => {
          question.value = Number(this.needData.form.value[question.key]);
        });
      }
    });

    $(`#${this.selectedModal}`).modal('hide');
    this.selectedModal = '';
    this.showModal = false;
  }

  getValueInNeedItem(need: any, key: string) {
    let result;
    this.kycService.kyc.needs.needs.forEach(n => {
      if (n.key === need.key) {
        need.questionRaws.forEach(question => {
          if (question.key === key) {
            result = question.value;
          }
        });
      }
    });

    return result;
  }

  getGaugeChartLabelInNeedItem(need: any, key: string) {
    let result;
    this.kycService.kyc.needs.needs.forEach(n => {
      if (n.key === need.key) {
        need.questionRaws.forEach(question => {
          if (question.controlType === MyNeedsConstants.GAUGE_CHART && question.key === key) {
            result = question.options['labels'][Math.ceil((question.value + 90) / 30) - 1];
          }
        });
      }
    });

    return result;
  }

  onChangeAmountOfRegularSavings(value: number) {
    if (value) {
      this.amountOfRegularSavings = value;
    }
  }

  goToNextPage() {
    this.kycService.kyc.needs.completed = true;
    this.router.navigateByUrl('/journey/submit');
    this.navTabService.setActiveTab('submit');
  }
}



// WEBPACK FOOTER //
// ./src/app/features/my-needs/my-needs.component.ts